import { collection, get, all, update } from "typesaurus"

export interface ExternalSupports {
  id: string
  created: string
  lastModified: string
  name: string
  supportType: string
  [key: string]: any
}

const collection_ref = collection<ExternalSupports>("userAssessments")

export const getExternalSupportsById = (id: string) => {
  return get(collection_ref, id)
}

export const getAllExternalSupports = () => {
  return all(collection_ref)
}

export const updateExternalSupportsById = (
  id: string,
  newVals: Partial<ExternalSupports>
) => {
  return update(collection_ref, id, newVals)
}
